/**
 * 서비스 이름과 도메인. **여기 한 곳에서만 바꾼다.**
 *
 * 코드와 번역문에 이름을 직접 쓰지 않고,
 * 번역문에서는 `{appName}` 자리표시자를 쓴다. `t()` 가 자동으로 채운다.
 * index.html 의 제목은 vite.config.ts 가 빌드할 때 이 값으로 바꿔 넣는다.
 */
export const APP_NAME = 'Fatemap'

/** 한국어 화면의 이름 (브라우저 탭 이름에만 쓴다 —, "페이트맵 — 사주·타로") */
export const APP_NAME_KO = '페이트맵'

/** 이름 옆에 붙는 부제. 번역하지 않는다 (공유 미리보기·index.html). 탭 이름은 언어마다 `docSubtitle`. */
export const APP_SUBTITLE = 'Korean Saju & Tarot'

/**
 * 기기 저장소(localStorage) 키 접두사.
 * 서비스 이름이 바뀌어도 사용자가 저장한 사람·도감이 사라지지 않게 이름과 무관한 값으로 고정한다.
 */
export const STORAGE_PREFIX = 'saju'

/**
 * **한 언어 공간에 담을 수 있는 사주 수** (docs/design-locale-spaces.md).
 *
 * 언어 하나가 완전히 따로 떨어진 공간이고, 그 안에 내 사주 · 가족 · 친구 사주가
 * 이름표와 함께 쌓인다. 여기가 그 상한을 정하는 **한 곳**이다 — 서버가 이 값으로
 * 막는다 (막는 코드는 3단계에서 넣는다).
 */
export const MAX_CHARTS_PER_SPACE = 20
